<template>
  <BContainer
    fluid
    class="container-pages mb-3"
    v-if="subcategory.subcategory != null"
  >
    <BRow class="mb-3">
      <BCol xl="8" lg="7">
        <div class="p-element-page shadow bg-white rounded">
          <h1 class="h1-title">{{ title }}</h1>

          <nuxt-link :to="routePath({ name: 'cena-na-pijacama' })">
            <h2 class="text-info h2-subtitle text-uppercase">
              ponuda na pijacama u Srbiji | {{ titleReplace('Cene na pijacama u Srbiji:') }}
            </h2>
          </nuxt-link>

          <hr />

          <div class="select-year mb-4 mt-3">
            <p class="font-size-12 fw-bold text-uppercase">
              Izaberi nedelju:
            </p>

            <div
              class="week-switcher"
              v-if="orderedWeeks.length"
            >
              <button
                type="button"
                class="week-switcher-arrow"
                :disabled="currentWeekIndex <= 0"
                aria-label="Novija nedelja"
                @click="stepWeek(-1)"
              >
                <i class="esei icon-angle-left-solid"></i>
              </button>

              <div
                ref="trackRef"
                class="week-switcher-track"
              >
                <button
                  v-for="week in orderedWeeks"
                  :key="week.week"
                  type="button"
                  class="week-switcher-chip"
                  :class="{ active: week.week === selectWeek }"
                  @click="pickWeek(week)"
                >
                  <span
                    class="week-switcher-chip-num"
                    v-if="week.number"
                  >
                    {{ week.number }}. ned.
                  </span>
                  {{ weekChipLabel(week) }}
                </button>
              </div>

              <button
                type="button"
                class="week-switcher-arrow"
                :disabled="currentWeekIndex === -1 || currentWeekIndex >= orderedWeeks.length - 1"
                aria-label="Starija nedelja"
                @click="stepWeek(1)"
              >
                <i class="esei icon-angle-right-solid"></i>
              </button>
            </div>

            <p
              class="week-switcher-meta"
              v-if="currentWeekMeta"
            >
              Trenutno izabrana nedelja: <strong>{{ currentWeekMeta }}</strong>
            </p>
          </div>

          <div
            class="a-container mt-2 mb-2"
            v-if="$screen.showMobileAds"
          >
            <AdsPriceMobile />
          </div>

          <div>
            <button
              class="btn btn-info btn-sm mb-3 text-uppercase"
              @click="backToCategorySr"
            >
              nazad na stranicu -
              {{ subcategory?.subcategory?.description_path }}
            </button>
          </div>
          
    <div class="mt-3 mb-3">

    <NuxtLink
    :key="subcategory?.subcategory?.title_path"
    :to="`/cene-istorija/${categoryHistoryPath}`"
    class="price-history-cta"
>
    <div class="price-history-cta-content">
        

        <div>
            <span class="price-history-cta-label">
                Istorija cena
            </span>

            <strong class="price-history-cta-title">
                Pogledajte istorijat
                {{ subcategory?.subcategory?.title_path.toLowerCase() }}
            </strong>
        </div>
    </div>

    <i class="esei icon-angle-right-solid"></i>
</NuxtLink>

          </div>

          <div
            class="d-flex page-price-description"
            v-if="
              lang === 'sr' &&
              checkDescriptionDisplay(subcategory?.subcategory?.description_page)
            "
          >
            <div
              :class="btn ? 'd-none' : 'd-block'"
              v-html="
                descriptionDisplay(
                  subcategory.subcategory.description_page,
                  false
                )
              "
              @click="btn = !btn"
            ></div>

            <div
              :class="btn ? 'd-block' : 'd-none'"
              class="w-80"
              v-html="
                descriptionDisplay(
                  subcategory.subcategory.description_page,
                  true
                )
              "
              @click="btn = !btn"
            ></div>

            <i
              id="down-awesome"
              @click="btn = !btn"
              class="esei icon-chevron-down d-flex text-right ms-2 mt-1"
            ></i>
          </div>

          <!-- prosleđujemo useAsyncData rezultat child stranici -->
          <!-- <NuxtPage :items="items" /> -->

  <div class="a-container mt-2 mb-2" v-if="$screen.showMobileAds">
          <AdsPriceTopRight />
        </div>

 <div v-if="items?.data?.items && title">
    <div
      v-for="item in items.data.items"
      :key="item.category"
      style="overflow-x: auto"
    >
      <hr />
      <p class="text-uppercase font-size-12 fw-bold mb-2 mt-3">
        {{ tableTitle(item.title) }}
      </p>

      <div v-if="item.table.markets.length > 0">
        <TableDisplay
          :table_fields="item.table.map"
          :items_table="item.table.markets"
          :rate="items.data.exchange"
          :lang="lang"
        />
         
      </div>
    
      <div v-else>
        <BAlert
          :model-value="true"
          variant="danger"
          class="text-center text-uppercase fw-bold"
        >
          Trenutno nema podataka
        </BAlert>
      </div>
      
    </div>
         <div>
       <p>Izvor:  <a href="https://www.stips.minpolj.gov.rs/srl"
                rel="noreferrer"
                target="_blank">Stips</a> </p>
    <p>Izvor:  Korisnici </p>       
     </div>
    <div class="a-container mt-2 mb-2" v-if="$screen.isProduction">
      <AdsPriceBottom />
    </div>
  </div>
        </div>
     <FaqCard v-if="faq" :faq="faq"></FaqCard>

      </BCol>

      <BCol xl="4" lg="5">
        <div class="a-container mt-2 mb-2" v-if="$screen.showDesktopAds">
          <AdsPriceTopRight />
        </div>

        <TopAdsPages
          v-if="items?.data?.ad?.data"
          :items="items.data.ad.data"
          :category_name="''"
          :display_img="true"
        />
      </BCol>
    </BRow>
  </BContainer>
</template>

<script setup>
import { BCol, BContainer, BRow, BAlert } from 'bootstrap-vue-next'
import { useStipsWeekStore } from '~/stores/stips/week'

import SelectWeekByRoute from '~/util/localization/findSelectWeekByRoute'
import localizationLang from '~/util/localization/localizationItemsSubcategory'
import formatTitle from '~/util/stips/titleTable'
import findIncludes from '~/util/localization/typeIncludesTextTable'
import TopAdsPages from '~/components/widgets/Advertisement/TopAdsPages.vue'
import AdsPriceMobile from '~/components/GoogleAdvertisements/AdsPriceMobile.vue'
import AdsPriceTopRight from '~/components/GoogleAdvertisements/AdsPriceTopRight.vue'
import AdsPriceBottom from '~/components/GoogleAdvertisements/AdsPriceBottom.vue'
import TableDisplay from '~/components/widgets/DisplayTable/Table.vue';
import FaqCard from '~/components/widgets/Advertisement/FaqCard.vue';

import { useShareMetaStore } from "~/stores/shareMeta";
const shareMeta = useShareMetaStore();

const config = useRuntimeConfig()
 
const routePath = useRoutePath()

const locale = ref('sr')
 
const lang = computed(() =>  locale.value)

const route = useRoute()
const router = useRouter()

const title = ref(null)
const btn = ref(false)
const subcategory = ref(null)

const useStoreWeek = useStipsWeekStore()

// ---------- helperi nad weeks parametrom ----------

const weeksParam = computed(() => String(route.params.weeks ?? ''))

const getCategoryRoute = (weeks) =>
  weeks.split('-')[weeks.split('-').length - 2]

const getSubcategoryRoute = (weeks) =>
  weeks.split('-')[weeks.split('-').length - 3]

const getYearRoute = (weeks) => {
  const parts = String(weeks).split('-')
  const year = parseInt(parts[parts.length - 1])
  return isNaN(year) ? new Date().getFullYear() : year
}

const yearParam = computed(() => getYearRoute(weeksParam.value))

const selectWeekByRoute = (weeks) => {
  if (weeks.includes('od')) {
    const part = weeks.split('od')[1].split('-')
    return `${part[1]} ${part[2]} ${part[3]}`
  }

  if (weeks.includes('from')) {
    const part = weeks.split('from')[1].split('-')
    return `${part[1]} ${part[2].replace('to', 'do')} ${part[3]}`
  }

  return ''
}

// trenutno izabrana nedelja (string "DD.MM.YYYY do DD.MM.YYYY")
const selectWeek = ref(selectWeekByRoute(weeksParam.value))

// ---------- redizajn: traka nedelja ----------

const monthNamesSr = [
  'januar', 'februar', 'mart', 'april', 'maj', 'jun',
  'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'
]

const parseWeekParts = (week) =>
  String(week?.week || '').match(/\d{1,2}\.\d{1,2}\.\d{4}/g) || []

const weekChipLabel = (week) => {
  const parts = parseWeekParts(week)
  if (parts.length < 2) return week?.week || ''

  const [sd, sm] = parts[0].split('.')
  const [ed, em] = parts[1].split('.')

  return `${sd}.${sm} – ${ed}.${em}.`
}

// ---------- description helperi ----------

const descriptionDisplay = (description, isFull) =>
  !isFull ? description.substring(0, 100) + '...' : description

const checkDescriptionDisplay = (description) =>
  (description ?? '').length > 0

// ---------- inicijalizacija subcategory + title ----------

subcategory.value = localizationLang.findLangWeeks(
  lang.value,
  weeksParam.value
)

title.value = formatTitle.convert(
  weeksParam.value,
  findIncludes.convert(weeksParam.value, lang.value),
  lang.value
)

// slug ne postoji (npr. engleski slug): 301 na početnu, bez error stranice
if (!subcategory.value?.subcategory) {
  await navigateTo('/', { redirectCode: 301, replace: true })
}

const categoryHistoryPath = computed(() => {
    return subcategory.value?.subcategory?.title_path
        ?.split(' ')
        .join('-')
        .toLowerCase() ?? '';
});

const titleReplace = (text) => text.replace(':', '')

// API vraca kljuc naslova tabele (markets, farm, silo...); tekstovi su ranije bili u i18n prevodu
const tableTitles = {
  markets: 'Cene na pijacama u Srbiji:',
  farm: 'Cene gazdinstvo:',
  silo: 'Cene silos:',
  retail: 'Cene maloprodaja:',
  livestock: 'Cene na stočnim pijacama:',
  slaughterhouses: 'Cene u klanicama:',
  price_market_kv: 'Cene na kvantašu:',
}
const tableTitle = (key) => tableTitles[key] ?? key

// ---------- parametri za API ----------

const categoryParam = computed(() => getCategoryRoute(weeksParam.value))

const weekParam = computed(() =>
  SelectWeekByRoute.findCurrentWeek(weeksParam.value, lang.value)
)

const productParam = computed(() =>
  findIncludes.convert(weeksParam.value, lang.value)
)

// ---------- useAsyncData – JEDAN API poziv ----------

const {
  data: items,
  error,
  pending
} = await useAsyncData(
  () =>
    `items-${categoryParam.value}-${productParam.value}-${weekParam.value}-${yearParam.value}`,
  () =>
    useStoreWeek.getByCategoryWeek({
      year: yearParam.value,
      category: categoryParam.value,
      product: productParam.value,
      week: weekParam.value
    }),
    
    
  {
    watch: [weeksParam, yearParam, categoryParam, productParam, weekParam]
  }
)

const faq = computed(() => {
  const markets = items.value?.data?.items?.[0]?.table?.markets ?? []
  return markets
    ?.flatMap(market => {
      try {
        return typeof market.faq === 'string'
          ? JSON.parse(market.faq)
          : (market.faq || [])
      } catch {
        return []
      }
    })
    ?.slice(0, 20) || []
})

// ---------- traka nedelja: izvedene vrednosti + skrol ----------

// nedelje poređane od najnovije (levo) ka najstarijoj (desno) — skrol ide unazad
const orderedWeeks = computed(() =>
  [...(items.value?.data?.weeks || [])]
)

const currentWeekIndex = computed(() =>
  orderedWeeks.value.findIndex(w => w.week === selectWeek.value)
)

const currentWeekMeta = computed(() => {
  const w = orderedWeeks.value[currentWeekIndex.value]
  if (!w) return ''

  const parts = parseWeekParts(w)
  const bits = []

  if (w.number) bits.push(`Nedelja ${w.number}`)

  if (parts.length) {
    const [, mm, yyyy] = parts[0].split('.')
    const monthName = monthNamesSr[parseInt(mm, 10) - 1]
    if (monthName) bits.push(`${monthName} ${yyyy}.`)
  }

  return bits.join(' · ')
})

// skrol trake do trenutno izabrane nedelje
const trackRef = ref(null)

const scrollToActiveWeek = async () => {
  await nextTick()

  const track = trackRef.value
  if (!track) return

  const active = track.querySelector('.week-switcher-chip.active')
  if (!active) return

  track.scrollTo({
    left: active.offsetLeft - track.clientWidth / 2 + active.offsetWidth / 2,
    behavior: 'smooth'
  })
}

onMounted(scrollToActiveWeek)
watch([selectWeek, orderedWeeks], scrollToActiveWeek)

// ---------- promene nedelje ----------

const pickWeek = (week) => {
  if (!week || week.week === selectWeek.value) return
  selectWeek.value = week.week
  createRouteBySr()
}

const stepWeek = (dir) => {
  const next = orderedWeeks.value[currentWeekIndex.value + dir]
  if (next) pickWeek(next)
}

const createRouteBySr = () => {
  const base = weeksParam.value.split('-od-')[0]
  const sub = getSubcategoryRoute(weeksParam.value)
  const cat = getCategoryRoute(weeksParam.value)
  const year = yearParam.value

  const newRoute =
    base +
    '-od-' +
    selectWeek.value.split(' ').join('-') +
    '-' +
    sub +
    '-' +
    cat +
    '-' +
    year

  router.push('/cena/' + newRoute)
}

// ---------- povratak na kategoriju ----------

const backToCategorySr = () => {
  const backRoute = subcategory.value.subcategory.description_path
    .split(' ')
    .join('-')
    .toLowerCase()

  router.push(
    '/cena-na-pijaci/' +
      backRoute +
      '-' +
      getSubcategoryRoute(weeksParam.value) +
      '-' +
      getCategoryRoute(weeksParam.value) +
      '-' +
      yearParam.value
  )
}

// ---------- reakcija na promenu rute ----------

watch(
  () => route.path,
  () => {
    const w = weeksParam.value

    title.value = formatTitle.convert(
      w,
      findIncludes.convert(w, lang.value),
      lang.value
    )

    selectWeek.value = selectWeekByRoute(w)
  }
)

const canonicalUrl = computed(() => `https://pijace.com${route.fullPath}`)

// JSON-LD: Dataset za cene na pijacama (Google ima dedicated rich result)
const datasetLd = computed(() => {
  const sub = subcategory.value?.subcategory
  const data = items.value?.data
  if (!sub || !title.value) return null

  // Proizvodi prikazani u tabeli
  const products = (data?.items || [])
    .map(i => i.title)
    .filter(Boolean)

  // Sve unique pijace iz svih tabela (spatialCoverage)
  const marketSet = new Set()
  ;(data?.items || []).forEach(it => {
    ;(it.table?.markets || []).forEach(m => {
      const name = m?.market || m?.market_name || m?.name
      if (name) marketSet.add(name)
    })
  })
  const markets = [...marketSet]

  // Dataset description MORA biti 50–5000 karaktera (Google Search Console
  // baca 'Invalid string length in field "description"' ako je kraći).
  // buildDatasetDescription kombinuje sve dostupne podatke i padding-uje
  // ako je rezultat ispod 50 karaktera. Definisan u utils/datasetDescription.ts.
  const datasetDescription = buildDatasetDescription({
    description: sub.description_meta,
    title: title.value,
    products,
    markets,
    year: yearParam.value,
    lang: lang.value
  })

  return {
    '@context': 'https://schema.org',
    '@type': 'Dataset',
    name: title.value,
    description: datasetDescription,
    url: canonicalUrl.value,
    license: 'https://pijace.com/uslovi-koriscenja',
    inLanguage: lang.value,
    temporalCoverage: String(yearParam.value),
    keywords: [
      'cene',
      'pijace',
      'cena na pijacama',
      ...products,
      String(yearParam.value)
    ].join(', '),
    creator: {
      '@type': 'Organization',
      name: 'Pijace.com',
      url: 'https://pijace.com'
    },
    publisher: {
      '@type': 'Organization',
      name: 'Pijace.com',
      url: 'https://pijace.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://pijace.com/images/pijace-60.png'
      }
    },
    ...(markets.length > 0
      ? {
          spatialCoverage: {
            '@type': 'Place',
            name: markets.join(', ')
          }
        }
      : {})
  }
})

// JSON-LD: BreadcrumbList — Cene na pijacama → trenutna nedelja
const breadcrumbLd = computed(() => {
  const sub = subcategory.value?.subcategory
  if (!sub || !title.value) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Cene na pijacama',
        item: 'https://pijace.com/cena-na-pijacama'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: sub.description_path || title.value,
        item: canonicalUrl.value
      }
    ]
  }
})

watchEffect(() => {
  if (!subcategory.value?.subcategory || !title.value) return
  shareMeta.setMeta({
    title: title.value,
    description: subcategory.value.subcategory.description_meta,
    url: `${config.public.API_BASE}${route.fullPath}`,
  })
})

// Helper: izvlači datume iz naslova tipa
// "Cene jagnjadi na pijacama za mesec jun od 01.06.2026 do 07.06.2026"
// → { startISO: '2026-06-01T00:00:00+02:00', endISO: '2026-06-07T23:59:59+02:00' }
const extractWeekDatesFromTitle = (titleStr) => {
  if (!titleStr) return null

  // Match svaki dd.mm.yyyy obrazac (radi i za sr "od/do" i en "from/to")
  const matches = String(titleStr).match(/\d{2}\.\d{2}\.\d{4}/g)
  if (!matches || matches.length < 2) return null

  const toIso = (ddMmYyyy, endOfDay = false) => {
    const [dd, mm, yyyy] = ddMmYyyy.split('.')
    const time = endOfDay ? 'T23:59:59+02:00' : 'T00:00:00+02:00'
    return `${yyyy}-${mm}-${dd}${time}`
  }

  return {
    startISO: toIso(matches[0], false),
    endISO: toIso(matches[1], true),
  }
}

// FAQ schema — reuse-uje POSTOJEĆI `faq` computed (linija 287) koji
// ekstraktuje pitanja iz items.data.items[0].table.markets[].faq i
// koji već prikazuje <FaqCard :faq="faq">. Bitno: schema MORA da odgovara
// vidljivom sadržaju na strani, inače Google može da javi "hidden content".
//
// Datumi (datePublished, dateModified, validThrough, temporalCoverage) se
// izvlače iz naslova ("...od 01.06.2026 do 07.06.2026"). Pomaže Google-u i
// AI agentima da znaju koja nedelja je relevantna i kad ti podaci ističu.
const faqSchemaLd = computed(() => {
  const list = faq.value
  if (!Array.isArray(list) || !list.length) return null

  const questions = list
    .filter(q => q?.question && q?.answer)
    .map(q => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer
      }
    }))

  if (!questions.length) return null

  const weekDates = extractWeekDatesFromTitle(title.value)

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    ...(weekDates?.startISO ? { datePublished: weekDates.startISO } : {}),
    ...(weekDates?.endISO ? {
      dateModified: weekDates.endISO,
      validThrough: weekDates.endISO,
    } : {}),
    ...(weekDates?.startISO && weekDates?.endISO ? {
      temporalCoverage: `${weekDates.startISO.slice(0, 10)}/${weekDates.endISO.slice(0, 10)}`
    } : {}),
    mainEntity: questions
  }
})

usePijaceSeo({
  title: () => title.value || '',
  description: () => subcategory.value?.subcategory?.description_meta ?? '',
  url: canonicalUrl,
  type: 'website',
  locale: lang,
  jsonLd: () => [datasetLd.value, breadcrumbLd.value, faqSchemaLd.value],
})
</script>

<style>
</style>
